import { gql } from '@apollo/client'

export const ADD_MASTER_BOAT_ROUTE = gql`
    mutation AddMasterBoatRoute($masterBoatRoute: MasterBoatRouteInput!) {
        addMasterBoatRoute(master_boat_route: $masterBoatRoute) {
            code
            success
            message
        }
    }
`
export const UPDATE_MASTER_BOAT_ROUTE = gql`
    mutation UpdateMasterBoatRoute($masterRouteId: NonEmptyString!, $masterBoatRoute: MasterBoatRouteInput!) {
        updateMasterBoatRoute(master_route_id: $masterRouteId, master_boat_route: $masterBoatRoute) {
            code
            success
            message
        }
    }
`

export const ADD_BOAT_ROUTE = gql`
    mutation AddBoatRoute($boatRoute: BoatRouteInput!) {
        addBoatRoute(boat_route: $boatRoute) {
            code
            success
            message
        }
    }
`
export const UPDATE_BOAT_ROUTE = gql`
    mutation UpdateBoatRoute($routeId: NonEmptyString!, $boatRoute: BoatRouteInput!) {
        updateBoatRoute(route_id: $routeId, boat_route: $boatRoute) {
            code
            success
            message
        }
    }
`
export const ADD_BOAT_ROUTE_TRIP = gql`
    mutation AddBoatRouteTrip($boatRouteTrip: BoatRouteTripInput!) {
        addBoatRouteTrip(boat_route_trip: $boatRouteTrip) {
            code
            success
            message
        }
    }
`
export const UPDATE_BOAT_ROUTE_TRIP = gql`
    mutation UpdateBoatRouteTrip($boatRouteTrip: BoatRouteTripInput!, $tripId: NonEmptyString!) {
        updateBoatRouteTrip(boat_route_trip: $boatRouteTrip, trip_id: $tripId) {
            code
            success
            message
        }
    }
`
export const UPDATE_BOAT_ROUTE_PRICE = gql`
    mutation UpdateBoatRoutePrice($routeId: NonEmptyString!, $prices: [BoatRoutePriceInput!]!) {
        updateBoatRoutePrice(route_id: $routeId, prices: $prices) {
            code
            success
            message
        }
    }
`
export const ADD_CAPTAIN_SHIFT_SCHEDULE = gql`
    mutation CreateCaptainShiftSchedule($captainShiftSchedule: CaptainShiftScheduleInput!) {
        createCaptainShiftSchedule(captain_shift_schedule: $captainShiftSchedule) {
            code
            success
            message
        }
    }
`
export const UPDATE_CAPTAIN_SHIFT_SCHEDULE = gql`
    mutation UpdateCaptainShiftSchedule(
        $captainShiftSchedule: CaptainShiftScheduleInput!
        $shiftScheduleId: NonEmptyString!
    ) {
        updateCaptainShiftSchedule(captain_shift_schedule: $captainShiftSchedule, shift_schedule_id: $shiftScheduleId) {
            code
            success
            message
        }
    }
`
export const ADD_BOAT_ROUTE_ASSIGNMENT = gql`
    mutation AddBoatRouteAssignment($boatRouteAssignment: BoatRouteAssignmentInput) {
        addBoatRouteAssignment(boat_route_assignment: $boatRouteAssignment) {
            code
            success
            message
        }
    }
`
export const UPDATE_BOAT_ROUTE_ASSIGNMENT = gql`
    mutation UpdateBoatRouteAssignment(
        $assignmentId: NonEmptyString!
        $startDate: LocalDate!
        $endDate: LocalDate
        $statusCode: NonEmptyString!
    ) {
        updateBoatRouteAssignment(
            assignment_id: $assignmentId
            start_date: $startDate
            end_date: $endDate
            status_code: $statusCode
        ) {
            code
            success
            message
        }
    }
`
export const REFRESH_ROUTE_SEAT_ASSIGNMENT = gql`
    mutation RefreshRouteSeatAssignment {
        refreshRouteSeatAssignment {
            code
            success
            message
        }
    }
`
export const UPDATE_BOAT_ROUTE_LUGGAGE_PRICE = gql`
    mutation updateBoatRouteLuggagePrice($routeId: NonEmptyString!, $extraLuggagePriceConfig: PriceConfigInput!) {
        updateBoatRouteLuggagePrice(route_id: $routeId, extra_luggage_price_config: $extraLuggagePriceConfig) {
            code
            success
            message
        }
    }
`

export const UPDATE_BOAT_ROUTE_SERVICE_FEE = gql`
mutation UpdateBoatRouteServiceFee($routeId: NonEmptyString!, $serviceFee: ServiceFeeInput!) {
  updateBoatRouteServiceFee(route_id: $routeId, service_fee: $serviceFee) {
    code
    success
    message
  }
}`
